<template>
  <div class="footer">
    <div class="row">
      <div class="w300 spc col">
        <br />
        <br />
        <img
          width="126"
          height="126"
          src="../assets/img/foot/studentElegantDemeanor/WxQrCode.png"
          alt="小程序"
        />
        <br />
        <br />
        <img
          width="238"
          height="57"
          src="../assets/img/foot/studentElegantDemeanor/spc.png"
          alt="小程序"
        />
      </div>
      <div class="col fl1">
        <div class="item">
          <img
            src="../assets/img/foot/YZLogoWhite.png"
            width="200"
            class="nonelogo"
          />
          <h3 class="item-title">联系我们</h3>
          <ul class="contact-ul">
            <li class="contact-li">
              <i class="iconfont iconphone" />
              <span>客服热线：1831927423</span>
            </li>
            <li class="contact-li">
              <i class="iconfont iconweixin" />
              <span>邮箱：162839482@163.com</span>
            </li>
            <li class="contact-li">
              <i class="iconfont iconweixin" />
              <span>客服微信：Yna1924294jz</span>
            </li>
            <li class="contact-li">
              <i class="iconfont iconposition" />
              <span>总部地址：惠州市惠城区江北富力国际中心1812</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="w300 col">
        <div class="item">
          <h3 class="item-title">关注我们</h3>
          <div class="codes">
            <div class="qr-code">
              <img
                width="126"
                height="126"
                src="../assets/img/foot/studentElegantDemeanor/WxQrCode.png"
                alt="小程序"
              />
              <div class="label">小程序</div>
            </div>
            <div class="qr-code">
              <img
                width="126"
                height="126"
                src="../assets/img/foot/studentElegantDemeanor/WxQrCode.png"
                alt="公众号"
              />
              <div class="label">公众号</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="record">
      <p class="mobnone">
        <a target="_blank" href="https://beian.miit.gov.cn">
          粤ICP备2022021070号</a
        >
      </p>
      <!-- <br />
      <p class="mobnone">
        <a target="_blank" href="https://beian.miit.gov.cn">
          <img src="../assets/img/foot/plice.png" /> 沪公网安备 31010402005955号
          沪ICP备12016779号-9
        </a>
      </p> -->
      <!-- <div style="width: 300px; margin: 0 auto; padding: 20px 0">
        <a
          target="_blank"
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44130202001013"
          style="
            display: inline-block;
            text-decoration: none;
            height: 20px;
            line-height: 20px;
          "
        ></a>
      </div>-->
    </div>
  </div>
</template>

<script lang="ts" setup></script>

<style lang="less" scoped>
.footer {
  background: #16181a;
  padding-top: 20px;
}

.slogan-pc {
  display: none;
}
.item {
  padding: 16px;
  text-align: center;
  .item-title {
    font-size: 18px;
    font-weight: 600;

    color: #fff;
    line-height: 25px;
  }
}

.qr-code {
  width: 126px;
  text-align: center;
  display: inline-block;

  .label {
    margin-top: 13px;
    font-size: 14px;
    color: #fff;
  }
}

.qr-code + .qr-code {
  margin-left: 20px;
}

.codes {
  margin-top: 15px;
  display: flex;
  justify-content: center;
}
h3 {
  text-align: center;
}
.contact-ul {
  margin-top: 24px;
  padding: 0 20%;

  li + li {
    margin-top: 22px;
  }

  .contact-li {
    font-size: 14px;
    font-weight: 400;
    color: #fff;

    line-height: 24px;

    .iconfont {
      font-size: 18px;
      margin-right: 5px;
      vertical-align: bottom;
    }
  }
}

.record {
  padding: 16px;
  font-size: 12px;
  color: #666666;
  img {
    vertical-align: bottom;
  }
  p {
    line-height: 20px;
    text-align: center;
  }
  div {
    a {
      p {
        color: #666666;
      }
    }
  }
  // .icon{
  // }
}

.logo-area {
  width: 44px;
  height: 44px;
  display: inline-block;
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}

.slogan {
  margin-left: 7px;
  height: 44px;
  line-height: 44px;
  font-size: 14px;
  display: inline-block;
  vertical-align: top;
  color: #e7792b;
}

@media screen and (max-width: 992px) {
  .row {
    margin: 0 auto;
    max-width: 720px;
  }
  .record {
    text-align: center;
    height: 54px;
  }

  .first {
    display: none;
  }
  .spc {
    display: none;
  }
  .mobnone {
    display: none;
  }
  .nonelogo {
    margin-bottom: 20px;
  }
}

@media screen and (min-width: 993px) {
  .row {
    margin: 0 auto;
    max-width: 1200px;
    display: flex;
  }
  .w300 {
    width: 300px;
  }
  .fl1 {
    flex: 1;
  }
  .first {
    display: block;
  }
  .logo-area {
    width: 106px;
    height: 75px;
    display: block;
  }
  .slogan {
    display: none;
  }
  .slogan-pc {
    margin-left: 7px;
    height: 44px;
    line-height: 44px;
    font-size: 24px;
    display: inline-block;
    vertical-align: top;
    color: #e7792b;
    margin: 22px 0 0 0;
  }
  .nonelogo {
    display: none;
  }
  .record {
    a {
      color: #fff;
    }
  }
}
</style>
